import { Delete } from 'lucide-react'

type Props = {
  value: string
  onChange: (v: string) => void
  allowDecimal?: boolean
  maxLen?: number
}

export default function KioskNumpad({ value, onChange, allowDecimal = false, maxLen = 8 }: Props) {
  const tap = (k: string) => {
    if (k === 'back') return onChange(value.slice(0, -1))
    if (k === '.' && (!allowDecimal || value.includes('.'))) return
    if (value.length >= maxLen) return
    onChange(value + k)
  }

  const keys = ['1','2','3','4','5','6','7','8','9', allowDecimal ? '.' : '', '0', 'back']

  return (
    <div className="grid grid-cols-3 gap-3 select-none">
      {keys.map((k, i) => k === '' ? <div key={i} /> : (
        <button
          key={i}
          onClick={() => tap(k)}
          className="h-16 rounded-xl bg-ink-100 hover:bg-ink-200 active:bg-ink-300 text-2xl font-semibold flex items-center justify-center transition"
        >
          {k === 'back' ? <Delete className="h-6 w-6" /> : k}
        </button>
      ))}
    </div>
  )
}
